import React from 'react'
import { useDispatch } from 'react-redux'
import { updateTrackedAccount } from 'actions/trackedAccounts'
import { List, ListItem, Box, ListItemText, ListItemAvatar, Avatar, makeStyles, ListItemSecondaryAction, Switch, Divider } from '@material-ui/core'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'
import AlertWrapper from 'components/AlertWrapper'
import useReconnectTrackedAccountProvider from 'hooks/useReconnectTrackedAccountProvider'
import useEntity from 'hooks/useEntity'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  nestedList: {
    paddingLeft: theme.spacing(4)
  }
}))

export default function Provider({ id }) {
  const startReconnect = useReconnectTrackedAccountProvider(id)
  const { encodedBankLogo, institutionName, deprecatedPlaidCredentials } = useEntity('trackedAccountProviders', id)
  const accounts = useCurrentUserEntities('trackedAccounts').filter((a) => a.trackedAccountProviderId === id)
  const classes = useStyles()
  const dispatch = useDispatch()

  return (
    <React.Fragment key={id}>
      <ListItem>
        <ListItemAvatar>
          <Avatar src={`data:image/png;base64, ${encodedBankLogo}`}/>
        </ListItemAvatar>
        <ListItemText primary={institutionName} />
      </ListItem>
      {deprecatedPlaidCredentials && (
        <Box mb={1} ml={2}>
          <AlertWrapper
            severity='error'
            message='Login to reconnect accounts'
            actionHandler={() => startReconnect()}
            actionText='login'
          />
        </Box>
      )}
      <Divider variant='inset' component='li' />
      <List className={classes.nestedList}>
        {accounts.map(({ id, paused, name, mask }) => (
          <ListItem key={id}>
            <ListItemText primary={name} secondary={`•••••••••${mask}`} />
            <ListItemSecondaryAction>
              <Switch
                checked={!paused}
                edge='end'
                onChange={() => dispatch(updateTrackedAccount(id, { paused: !paused }))}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </React.Fragment>
  )
}

Provider.propTypes = {
  id: PropTypes.string.isRequired
}
